import { render, staticRenderFns } from "./AssociatesView.vue?vue&type=template&id=56793364&scoped=true"
import script from "./AssociatesView.vue?vue&type=script&lang=ts"
export * from "./AssociatesView.vue?vue&type=script&lang=ts"
import style0 from "./AssociatesView.vue?vue&type=style&index=0&id=56793364&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56793364",
  null
  
)

export default component.exports